import Phaser from 'phaser'
import { SymbolSizeBox, SymbolToAsset, type SymbolKey } from '@/config/SlotConfig'

/**
 * 单个 Symbol(老虎机一格)
 *
 * 本质是一个 Phaser Image, 包装方便切换 symbol / 缩放对齐
 */
export class SlotSymbol extends Phaser.GameObjects.Image {
  private symbolKey: SymbolKey

  constructor(scene: Phaser.Scene, x: number, y: number, key: SymbolKey) {
    super(scene, x, y, SymbolToAsset[key])
    this.symbolKey = key
    this.setOrigin(0.5)
    this.fitToCell()
    this.setDepth(5)
    scene.add.existing(this)
  }

  /** 切换 symbol(滚动复用时用) */
  setSymbol(key: SymbolKey): void {
    this.symbolKey = key
    this.setTexture(SymbolToAsset[key])
    this.fitToCell()
  }

  getSymbol(): SymbolKey {
    return this.symbolKey
  }

  /** 把 sprite 缩到当前 game 的 SYMBOL_SIZE 内（运行时由 SymbolSizeBox 控制），保持原始比例 */
  private fitToCell(): void {
    const tex = this.texture.getSourceImage()
    const srcW = tex.width
    const srcH = tex.height
    const target = SymbolSizeBox.value
    const scale = Math.min(target / srcW, target / srcH)
    this.setScale(scale)
  }
}
